import { render, staticRenderFns } from "./LedMassMessageInfo.vue?vue&type=template&id=ed791940&"
import script from "./LedMassMessageInfo.vue?vue&type=script&lang=js&"
export * from "./LedMassMessageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports